// src/utils/parseCsv.js
// Petit parseur CSV tolérant (gère guillemets, retours ligne dans les cellules,
// et détection auto du séparateur ; , ou tabulation).

export function detectDelimiter(text) {
  const firstLine = String(text || "").split(/\r?\n/, 1)[0] || "";
  const counts = {
    ";": (firstLine.match(/;/g) || []).length,
    ",": (firstLine.match(/,/g) || []).length,
    "\t": (firstLine.match(/\t/g) || []).length,
  };
  let best = ",";
  let bestN = -1;
  for (const d of Object.keys(counts)) {
    if (counts[d] > bestN) {
      bestN = counts[d];
      best = d;
    }
  }
  return best;
}

export function parseCsv(text, delimiter) {
  const raw = String(text || "").replace(/^﻿/, ""); // enlève le BOM
  const delim = delimiter || detectDelimiter(raw);

  const rows = [];
  let row = [];
  let cell = "";
  let inQuotes = false;

  for (let i = 0; i < raw.length; i++) {
    const c = raw[i];

    if (inQuotes) {
      if (c === '"') {
        if (raw[i + 1] === '"') {
          cell += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cell += c;
      }
      continue;
    }

    if (c === '"') {
      inQuotes = true;
    } else if (c === delim) {
      row.push(cell);
      cell = "";
    } else if (c === "\n") {
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
    } else if (c === "\r") {
      // ignore (géré via \n)
    } else {
      cell += c;
    }
  }

  // dernière cellule / dernière ligne
  if (cell.length > 0 || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }

  // enlève les lignes entièrement vides
  return {
    delimiter: delim,
    rows: rows.filter((r) => r.some((v) => String(v).trim() !== "")),
  };
}
